module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./input.md");


//////////////////
// WEBPACK FOOTER
// ./examples/docs/input.md
// module id = WuKF
// module chunks = 1